/*
Special functions for the DEGS theme.
*/

jQuery(document).ready(function() {

    // Check screen size
    jQuery(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
	
    //console.log('Doings');
    jQuery("td:contains(✔)").addClass('cell-positive');
    jQuery("td:contains(✘)").addClass('cell-negative');


    function checkScreenSize(){
        var newWindowWidth = jQuery(window).width();
        if (newWindowWidth > 900) {

            // Check for a form in the main content area and move it to the sidebar.
            jQuery('.frm_forms').appendTo( jQuery('.sticky') );
            jQuery('.frm_forms').wrap('<div class="boxout boxout--sidebar boxout--post-menu boxout--sticky widget_frm_show_form"></div>');

            // Find a form in a sidebar, hide it and add a button to show it again
            jQuery('<button class="button button--fullwidth button--last button--show-fb-form">Leave feedback on this section</button>').insertBefore(".frm_forms");
            jQuery(".button--show-fb-form").click(function() {
            	jQuery(this).hide();
            	jQuery(this).next(".frm_forms").fadeIn('slow');
            });

            // Hide feedback forms
            jQuery(".frm_forms").hide();
        }
    }


    // Set a variable from the current page slug
    var postSlug = cx_post_vars.postSlug;
    var ancestorSlug = cx_post_vars.ancestorSlug;
    var postID = cx_post_vars.postID;

    // Check if form title matches current page slug and show form if so 

    if (jQuery(".frm_form_widget h2:contains("+postSlug+")")) {

        jQuery(".frm_form_widget h2:contains("+postSlug+")").closest(".widget_frm_show_form").show();
    } else {
        jQuery(".frm_form_widget h2:contains("+ancestorSlug+")").closest(".widget_frm_show_form").show();
    }
    

}); 